import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import stringifyParams from "@/utils/stringifyParams";

const useStudentPowerWordQuizGet = (queryParams = {}) => {
  const articleId = queryParams?.article_id;
  let resource = `${MONOLITH_ORIGIN}/api/v2/student-vocabulary-answer/`;
  resource = `${resource}${stringifyParams(queryParams)}`;

  return useLazyRestQuery(resource, { skip: !articleId });
};

export default useStudentPowerWordQuizGet;
